import { render, staticRenderFns } from "./PaymentCardDetails.vue?vue&type=template&id=c20ed2f6&scoped=true&"
import script from "./PaymentCardDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCardDetails.vue?vue&type=style&index=0&id=c20ed2f6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ed2f6",
  null
  
)

export default component.exports